// Shared helpers for the Find Jobs + Messages redesign.
// Role accent colors + labels + lucide icon names per design_handoff_findjobs_messages/TOKENS.md.

export const ROLE_META = {
  photographer:   { label: "Photographer", color: "#28C0D0", icon: "Camera" },
  videographer:   { label: "Videographer", color: "#78287C", icon: "Video" },
  editor:         { label: "Editor",       color: "#67C6B4", icon: "Scissors" },
  assistant:      { label: "Assistant",    color: "#572B7C", icon: "User" },
  drone_operator: { label: "Drone Op",     color: "#2563EB", icon: "Plane" },
};

export function roleMeta(role) {
  const key = (role || "").toLowerCase();
  return ROLE_META[key] || { label: (role || "").replace(/_/g, " "), color: "#8A90A2", icon: "Briefcase" };
}

export function roleColor(role) {
  return roleMeta(role).color;
}

// Money: "$" + en-AU grouping, no trailing cents unless present.
export function money(n) {
  const v = Number(n || 0);
  return "$" + v.toLocaleString("en-AU", { maximumFractionDigits: v % 1 === 0 ? 0 : 2 });
}

// Initial for avatar fallback.
export function initial(name) {
  return (name || "?").trim().charAt(0).toUpperCase() || "?";
}

// Deterministic brand-gradient tile background for avatar fallback (varies subtly by name).
export function avatarGradient(name) {
  return "linear-gradient(135deg, #572B7C, #78287C)";
}

// A job is "advanced" (multi-crew) when it has >1 crew_members, or is flagged.
export function isAdvancedJob(job) {
  if (!job) return false;
  const cm = job.crew_members || job.crewMembers || [];
  return (Array.isArray(cm) && cm.length > 1) || job.is_advanced_job === true || job.isAdvanced === true;
}

// "Up to" total for advanced jobs = sum of crew_members[].subtotal.
export function advancedTotal(job) {
  const cm = job?.crew_members || job?.crewMembers || [];
  return cm.reduce((s, m) => s + Number(m.subtotal || (m.hours || 0) * (m.ratePerHour || m.rate || 0) || 0), 0);
}
